module.exports = __webpack_public_path__ + "img/services-case3-4.b537a849.png";